export const PATH = '/cfdis';

export const roles = ['tableCFDI', 'tablePC'];
